import React from 'react';
import './Reviews.css';
import Popup from '../Popup/Popup'
import NLD from '../../img/reviews/NLD.jpg'
import Pacheco from '../../img/reviews/Pacheco.jpg';
import Kostenko from '../../img/reviews/Kostenko.jpg';
import Guzman from '../../img/reviews/Guzman.jpg';
import Mansur from '../../img/reviews/Mansur.jpg';
import Sarasola from '../../img/reviews/Sarasola.jpg';
import stars from '../../img/main/stars.png';
import quotes from '../../img/reviews/quotes.svg';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class Reviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [
        {
          id: 4,
          show: true,
          photo: NLD,
          name: 'Anne Nguyen Le Dieu Anh',
          title: `I'm really thankful that I got to participate on this event. It was great to experience such a strong and helpful global community and to learn so many interesting topics. Can't wait to attend the next one!`,
        },
        {
          id: 2,
          show: true,
          photo: Pacheco,
          name: 'Erwin Abelardo Pacheco',
          title: `There are no other platforms better then Geekle truly reaching out to industry's diverse immediate stakeholders us developers, designers and architects, extends to provide archive view of the summits online, and further prepares to empower us on this ever evolving industry.`,
        },
        {
          id: 3,
          show: true,
          photo: Kostenko,
          name: 'Evgeniy Kostenko',
          title: `Loved the format and content. Would love to see more prerecorded talks just to avoid live demo issues and bad internet connections, with live Q&A after. but I know this is a conference after all :)`,
        },
        {
          id: 1,
          show: true,
          photo: Guzman,
          name: 'Ian Mooreen De Guzman',
          title: `Thank you, Geekle for making this possible. For giving us a chance to learn and to get to know more about React. It helps us intermediates to be more aware of what we can do with React.`,
        },
        {
          id: 5,
          show: true,
          photo: Mansur,
          name: 'Lauro Mansur',
          title: `It has been an outstanding event to reinforce best practices and learn new ones.

          For anyone interested in knowing more about the content, I recommend the following talks to start with:
          
          - Component Driven Micro-frontends (Matt Briscoe, Adobe)
          - Why You Need a Design System (and How to Do It Right) (Tyler Hawkins, Adobe)
          - Componentizing Application State (Nick Nisi, C2FO)
          - Like a Newborn UI: I Want It Painted, App! (m4dz, ‹div›RIOTS)
          - Server Components: The Future of React (Elad Tzemach, Amazon)
          
          Thanks, Geekle.us, and all the speakers for the amazing content shared.`,
        },
        {
          id: 6,
          show: true,
          photo: Sarasola,
          name: 'Lucía Sarasola',
          title: `Attending made me realize I do apply architecture to my day to day work but never knew how much. Also introduced me to new knowledge about the industry. One of the most useful webinars I've ever attended. So lucky I've run into your call. Thanks for all the hard work it surely took you all to accomplish this. Amazing efforts. Keep rocking!`,
        },
      ]
    }
  }

  renderReviews(item, i) {
    return (
      <div className="reviews_item_wrap" key={`reviews_item-${i}`}>
        <div className='reviews_item'>
          <div className='reviews_item-content'>
            <img className='reviews_quotes' src={quotes} alt="" />
            {item.show && <div className='reviews_title'>
              {item.title.substring(0, 79)}...<Popup desc={item.title} title={item.name} key={i} />
            </div>}
            {!item.show && <div className='reviews_title'>
              {!item.show && <p>{item.title}</p>}
            </div>}
          </div>
          <div className='reviews_item-info'>
            <img className='reviews_photo' src={item.photo} alt="" />
            <div className="reviews_item_name_block">
              <p className="reviews_item_name">{item.name}</p>
              <img className="reviews_stars" src={stars} alt="" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="reviews black" id='reviews'>
        <div className='container reviews_wrap'>
          <h2>What <span className='title_gradient'>people</span> say</h2>
          <div className="review_block review_block--pc">
            {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
          </div>
          <div className="review_block review_block--mob">
            <Carousel showThumbs={false} showStatus={false} swipeable emulateTouch infiniteLoop>
              {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
            </Carousel>
          </div>
        </div>
      </div>
    )
  }
}